/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Breakpoints for accordion items. It's different from one in `@carbon/layout` library.
 */
export enum ACCORDION_ITEM_BREAKPOINT {
  /**
   * Small breakpoint.
   */
  SMALL = 'sm',

  /**
   * Medium breakpoint.
   */
  MEDIUM = 'md',
}

/**
 * Button size.
 */
export enum ACCORDION_SIZE {
  /**
   * Regular size.
   */
  REGULAR = '',

  /**
   * Small size.
   */
  SMALL = 'sm',

  /**
   * X-Large size.
   */
  EXTRA_LARGE = 'xl',
}
